import { render, staticRenderFns } from "./MyFavoriteDevice.vue?vue&type=template&id=5ce992f2&scoped=true&"
import script from "./MyFavoriteDevice.vue?vue&type=script&lang=js&"
export * from "./MyFavoriteDevice.vue?vue&type=script&lang=js&"
import style0 from "./MyFavoriteDevice.vue?vue&type=style&index=0&id=5ce992f2&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ce992f2",
  null
  
)

export default component.exports